<template>
  <div v-if="!loading">
    <ProductsCard class="mt2" :style="{ '--selected': 'var(--violet)', '--selected-item': 'var(--violet)' }" @offer-selected="offerSelected" />

    <StepAction :disabled="!selectedOffer" @handleClickAction="handleProductStep" />
  </div>

  <Loader v-else />
</template>

<script setup>
import { inject, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from '@/store/index';
import { handleProduct } from '@/utils/logics';
import { computeCourtDataLayer } from '@/utils/index';

import ProductsCard from '@/components/products/ProductsCard.vue';
import Loader from '@/components/elements/Loader.vue';

import StepAction from '@/components/terrain/StepAction.vue';

const store = useStore();
const route = useRoute();

const advanceStep = inject('advanceStep');

const loading = ref(false);
const handleInitialOptionStep = inject('handleInitialOptionStep');
const loadPreviousStep = inject('loadPreviousStep');

const selectedOffer = ref(null);
const selectedProduct = ref(null);

const isInvite = computed(() => store.state.courtSettings.isInvite || false);

const offerSelected = ({ product, offerCode }) => {
  selectedProduct.value = product;
  selectedOffer.value = offerCode;
};

const handleProductStep = async () => {
  loading.value = true;

  await handleProduct(selectedProduct.value, selectedOffer.value);
  computeCourtDataLayer('CourtProducts', { ...store.state.courtSettings }, route.fullPath, { ...store.state.product }, { ...store.state.offerInfo });

  store.commit('setCourtSettings', { ...store.state.courtSettings, selectedProduct: selectedProduct.value, selectedOffer: selectedOffer.value, fromProductStep: true, isCaptainPlaying: !isInvite.value });
  handleInitialOptionStep();
  loadPreviousStep();
  loading.value = false;
  advanceStep();
};

</script>
